module.exports = __webpack_public_path__ + "static/happy-children-622a26b0c2823742d7ccd440d397d63f.jpg";